import { createModel } from '@rematch/core'
import { RootModel } from '..'

interface ICommonModel {
  notificationState: { [key: string]: string | null }
}
const intialState: ICommonModel = {
  notificationState: {
    message: null,
    description: null,
    type: null,
  },
}

// Helper to check if session has expired (avoid circular import)
const isSessionExpired = (): boolean => {
  // Read from sessionStorage flag set by tokenRefresh
  return sessionStorage.getItem('wizr_session_expired') === 'true'
}

export const commonModel = createModel<RootModel>()({
  state: intialState as ICommonModel,
  reducers: {
    updateNotificationState: (state, payload: { [key: string]: string | null }) => {
      // Suppress error notifications when session has expired to prevent
      // confusing error toasts alongside the session expired modal
      if (payload.type === 'failed' && isSessionExpired()) {
        return state // Don't update state, effectively suppressing the notification
      }
      
      return {
        ...state,
        notificationState: payload,
      }
    },
  },
})
